import React, { useState, useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faWifi } from "@fortawesome/free-solid-svg-icons"
import "./index.scss"

/**
 * Offline Indicator Component
 *
 * Shows a banner when the user loses internet connection.
 * Automatically hides when connection is restored.
 */
const OfflineIndicator = () => {
	const [isOffline, setIsOffline] = useState(!navigator.onLine)
	const [showBanner, setShowBanner] = useState(false)

	useEffect(() => {
		const handleOnline = () => {
			setIsOffline(false)
			// Keep banner visible briefly to show "Back online" message
			setTimeout(() => {
				setShowBanner(false)
			}, 2000)
		}

		const handleOffline = () => {
			setIsOffline(true)
			setShowBanner(true)
		}

		window.addEventListener("online", handleOnline)
		window.addEventListener("offline", handleOffline)

		// Set initial state
		if (!navigator.onLine) {
			setShowBanner(true)
		}

		return () => {
			window.removeEventListener("online", handleOnline)
			window.removeEventListener("offline", handleOffline)
		}
	}, [])

	if (!showBanner) return null

	return (
		<div className={`OfflineIndicator ${isOffline ? "offline" : "online"}`}>
			<FontAwesomeIcon icon={faWifi} className="wifi-icon" />
			<span>{isOffline ? "You're offline - some content may be unavailable" : "Back online!"}</span>
		</div>
	)
}

export default OfflineIndicator
